import { Injectable } from '@angular/core';

@Injectable()
export class ConstantsService {

  public apiURL;
  public versionNumber;

  constructor() {
    // Prod ProfinBox
    this.apiURL = 'https://api.klabebox.com/api';
    //Prod
    // this.apiURL = 'https://api.profinmex.com/api';
    //QA
    // this.apiURL = 'https://qaprofinmexapi.inflexionsoftware.com/api';
    //STG
    // this.apiURL = "http://stgprofinmexapi.inflexionsoftware.com/api"
    // Local
    // this.apiURL = 'http://127.0.0.1/profinmex-api/public/api';
    this.versionNumber = '1.9.10r3';
  }

}



// WEBPACK FOOTER //
// ./src/app/services/constants.service.ts